import { Action } from '@ngrx/store';
import { Follow, Country, Member } from '@app/models';

export enum MemberActionTypes {
  Load = '[API] Load follow members',
  LoadSuccess = '[API] Load follow members Success',
  LoadFail = '[API] Load follow members Fail',
  LoadMe = '[API] Load follow members by user',
  LoadMeSuccess = '[API] Load follow members by user Success',
  LoadMeFail = '[API] Load follow members by user Fail',
  Create = '[API] Create follow members',
  CreateSuccess = '[API] Create follow members Success',
  CreateFail = '[API] Create follow members Fail',
  Update = '[API] Update follow members',
  UpdateSuccess = '[API] Update follow members Success',
  UpdateFail = '[API] Update follow members Fail',
  Remove = '[API] Delete follow members',
  RemoveSuccess = '[API] Delete follow members Success',
  RemoveFail = '[API] Delete follow members Fail'
}

export class Load implements Action {
  readonly type = MemberActionTypes.Load;
  constructor(public id: number) { }
}

export class LoadSuccess implements Action {
  readonly type = MemberActionTypes.LoadSuccess;
  constructor(public members: any) { }
}

export class LoadFail implements Action {
  readonly type = MemberActionTypes.LoadFail;
  constructor(public error: any) { }
}

export class LoadMe implements Action {
  readonly type = MemberActionTypes.LoadMe;
  constructor(public UserId: number) { }
}

export class LoadMeSuccess implements Action {
  readonly type = MemberActionTypes.LoadMeSuccess;
  constructor(public members: any) { }
}

export class LoadMeFail implements Action {
  readonly type = MemberActionTypes.LoadMeFail;
  constructor(public error: any) { }
}

export class Create implements Action {
  readonly type = MemberActionTypes.Create;
  constructor(public FollowId: number, public UserId: number) { }
}

export class CreateSuccess implements Action {
  readonly type = MemberActionTypes.CreateSuccess;
  constructor(public member: Member) { }
}

export class CreateFail implements Action {
  readonly type = MemberActionTypes.CreateFail;
  constructor(public error: any) { }
}

export class Update implements Action {
  readonly type = MemberActionTypes.Update;
  constructor(public data: any) { }
}

export class UpdateSuccess implements Action {
  readonly type = MemberActionTypes.UpdateSuccess;
  constructor(public member: Member) { }
}

export class UpdateFail implements Action {
  readonly type = MemberActionTypes.UpdateFail;
  constructor(public error: any) { }
}

export class Remove implements Action {
  readonly type = MemberActionTypes.Remove;
  constructor(public FollowId: number, public UserId: number) { }
}

export class RemoveSuccess implements Action {
  readonly type = MemberActionTypes.RemoveSuccess;
  constructor(public id: number) { }
}

export class RemoveFail implements Action {
  readonly type = MemberActionTypes.RemoveFail;
  constructor(public error: any) { }
}

export type MemberActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadMe
  | LoadMeSuccess
  | LoadMeFail
  | Create
  | CreateSuccess
  | CreateFail
  | Update
  | UpdateSuccess
  | UpdateFail
  | Remove
  | RemoveSuccess
  | RemoveFail;
